angular.module('cvsApp').factory('scheduleOrderModel', ['commonModel', function (CM) {
	'use strict';
	var scheduleOrderModel = function () {

		var apiResponse = {};

		var self = this;

		this.setResponse = function (data) {
			CM.setAGPResponse(data, 'scheduleOrderResponse');
		};

		this.getResponse = function () {
			self.apiResponse = CM.getResponse();
			self.header = CM.getHeader();
			return self;
		};

		this.showView = function () {
			if (self.apiResponse.isViewError) {
				return !self.apiResponse.isViewError;
			}
			return true;
		}

		this.getError = function () {
			if (self.apiResponse.showError) {
				return self.apiResponse.showError;
			}
			return '';
		};


		this.getscheduleOrderDetails = function () {
			if (!self.apiResponse.showError && self.apiResponse.scheduledOrder) {
				if (_.isArray(self.apiResponse.scheduledOrder)) {
					return self.apiResponse.scheduledOrder;
				}
			}
		};

	};

	return new scheduleOrderModel();
}]);